import { SettingsActionTypes, TOGGLE_DARK_MODE } from '../actions/settings.action';

export type SettingsState = {
  darkMode: boolean;
};

const initialState = {
  darkMode: false,
};

const settingsReducer = (state = initialState, action: SettingsActionTypes) => {
  if (action.type === TOGGLE_DARK_MODE) {
    const darkMode = !state.darkMode;
    return {
      ...state,
      darkMode,
    };
  }

  return state;
};

export default settingsReducer;
